import { Link } from 'react-router-dom';
import { MdEmail, MdPhone } from 'react-icons/md';

const ClientFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="client-footer"
      style={{
        background: 'linear-gradient(90deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)', color: 'white'
      }}>
      <div className="container py-4">
        <div className="row ">
          {/* Company Info */}
          <h2 className="footer-heading">Matrix ERP</h2>
          <p className="footer-text">
            Enterprise Resource Planning Solution
          </p>
          {/* Support & Contact Info */}
          <div className="col mx-auto">
            <ul className="footer-contact">
              <li><Link to="/contact-us" className="text-white">Contact Support</Link></li>
              <li>
                <MdEmail className="me-2" style={{ verticalAlign: 'middle' }} />
                <a href="mailto:support@matrixerp.com" className="text-white">support@matrixerp.com</a>
              </li>
              <li>
                <MdPhone className="me-2" />
                <a href="tel:+254719694420" className="text-white">+254 719 694 420</a>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="footer-bottom mt-4 pt-3 text-center border-top">
          <p className="mb-0">&copy; {currentYear} Matrix ERP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default ClientFooter;